import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TestType } from '../models/TestType';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TestTypeService {

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get<TestType[]>(`${environment.apiUrl}/testType/`);
  }
}
